import * as React from 'react';
import { Pressable, View } from 'react-native';
import { useStyles } from 'react-native-unistyles';

import { Icon } from '@/ui/icon';
import { Minus } from '@/ui/icons/minus';
import { Plus } from '@/ui/icons/plus';

type ZoomButtonsProps = {
  onIncrease: () => void;
  onDecrease: () => void;
};

export const ZoomButtons = ({ onIncrease, onDecrease }: ZoomButtonsProps) => {
  const { theme } = useStyles();

  return (
    <View
      style={{
        backgroundColor: theme.colors.zoomButtons.backgroundColor,
        borderRadius: 4,
        borderColor: theme.colors.zoomButtons.border,
        borderWidth: 1,
        padding: 4,
        gap: 4,
        justifyContent: 'space-between',
      }}
    >
      <Pressable onPress={onIncrease}>
        <View style={{ padding: 4 }}>
          <Icon
            type="naked"
            icon={<Plus />}
            fillColor={theme.colors.icon.color}
            width={12}
            height={12}
          />
        </View>
      </Pressable>

      <View
        style={{
          backgroundColor: theme.colors.zoomButtons.divider,
          height: 1,
          width: '90%',
        }}
      />

      <Pressable onPress={onDecrease}>
        <View style={{ padding: 4 }}>
          <Icon
            type="naked"
            icon={<Minus />}
            fillColor={theme.colors.icon.color}
            width={12}
            height={12}
          />
        </View>
      </Pressable>
    </View>
  );
};
